export default {
  data() {
    return {
      groups: [
        {
          key: "GENERAL",
          caption: 'ابزارهای عمومی',
          components: [
            {
              autoGenerate: true,
              type: "label",
              label: "برچسب",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
        {
          key: "STRING",
          caption: 'ابزارهای متنی',
          components: [
            {
              autoGenerate: true,
              type: "input",
              inputType: "text",
              label: "جعبه متن",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "input",
              inputType: "textarea",
              label: "متن چند خطی",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
        {
          key: "SELECTOR",
          caption: 'ابزارهای انتخابی',
          components: [
            {
              autoGenerate: true,
              type: "checkBox",
              label: "انتخاب مربعی",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "itemSelector",
              selectorType: 'combo', //Combo, Radio, drag, check list, two lists
              multiple: true,
              label: "انتخاب از لیست",
              items: [
                {
                  key: '1',
                  caption: 'آزمایش اول'
                },
                {
                  key: '2',
                  caption: 'آزمایش دوم'
                },
                {
                  key: '3',
                  caption: 'آزمایش سوم'
                }
              ],
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "modelSelector",
              selectorType: 'combo', //Combo, Radio, drag, check list, two lists
              multiple: true,
              label: "انتخاب اشیاء",
              valueField: 'id',
              displayField: 'caption',
              plugin: '',
              fetchDelegate: '',
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              selectorType: 'combo', //Combo, Radio, drag, check list, two lists
              type: "parameterSelector",
              multiple: true,
              label: "انتخاب پارامتر",
              parameterKey: '',
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
        {
          key: "DIGIT",
          caption: 'ابزارهای عددی',
          components: [
            {
              autoGenerate: true,
              type: "number",
              label: "عدد",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "percentage",
              label: "درصد",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "money",
              currency: "ریال",
              label: "مبلغ",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "moneyRange",
              currency: "ریال",
              label: "محدوده مبلغ",
              min: 15,
              max: 860,
              property: "x",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "numberRange",
              label: "محدوده عددی",
              min: 1,
              max: 99,
              property: "xx",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
        {
          key: "DATE",
          caption: 'ابزارهای تاریخ',
          components: [
            {
              autoGenerate: true,
              type: "datePicker",
              label: "انتخاب تاریخ",
              containTime: true,
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "monthPicker",
              label: "انتخاب ماه",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "timePicker",
              label: "انتخاب زمان",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "yearPicker",
              label: "انتخاب سال",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "dateRange",
              label: "محدوده تاریخ",
              start: undefined,
              end: undefined,
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "timeRange",
              label: "محدوده زمان",
              start: undefined,
              end: undefined,
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
        {
          key: "SPECIAL",
          caption: 'ابزارهای ویژه',
          components: [
            {
              autoGenerate: true,
              type: "audience",
              label: "مخاطب",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "colorPicker",
              label: "انتخاب رنگ",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "upload",
              label: "انتخاب فایل",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "password",
              label: "کلمه عبور",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "compositeList",
              label: "لیست وابسته",
              listStructureKey: 'parameterItem',
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "compositeDetail",
              label: "مدل وابسته",
              formStructureKey: 'parameterItem',
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "email",
              label: "پست الکترونیکی",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
            {
              autoGenerate: true,
              type: "url",
              label: "نشانی وب",
              property: "",
              disabled: false,
              note: '',
              placeholder: '',
              rules: undefined
            },
          ]
        },
      ],
    }
  },
};
